import { render, staticRenderFns } from "./DataManagementSummary.vue?vue&type=template&id=fdeef6fc&scoped=true&"
import script from "./DataManagementSummary.vue?vue&type=script&lang=js&"
export * from "./DataManagementSummary.vue?vue&type=script&lang=js&"
import style0 from "./DataManagementSummary.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DataManagementSummary.vue?vue&type=style&index=1&id=fdeef6fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdeef6fc",
  null
  
)

export default component.exports